import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import {useTranslation} from "react-i18next";

export default function CommunicationAssignmentList({ match }) {

    const {t} = useTranslation();

    const status = ['Open', 'Done', 'Canceled', 'Auto Closed'];

    const fields = [
        { name: t('Transfer Code'), keys: ['communicationEvent', 'communicationProcessId'] },
        { name: t('Country'), keys: ['country', 'name'] },
        { name: t('Required Action'), keys: ['requiredAction', 'name'], map:t },
        { name: t('Status'), key: 'status', map: (id) => t(status[id]) },
        { name: t('Last Update'), key: 'updatedAt', map: dateTimeFormatter },
        { name: t('Expected At'), key: 'expectedAt', map: dateTimeFormatter },
        { name: t('Created At'), key: 'createdAt', map: dateTimeFormatter },
    ];

    return (
        <ListCRUD
            resource='communicationAssignments'
            fields={fields}
            match={match}
            disableViewButton
            disableNewButton
            disableEditButton
        />
    );
};